import { useEffect, useState } from "react";

import {
    Modal,
    Form,
    Row,
    Col,
    Select,
    Input,
    InputNumber,
    Popconfirm,
    Button
} from "antd";
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { validateColor, validateQty, validatePrice } from "./validations";
import { fetchData, collections, checkCategory, APP_VERSION } from "../../utils";
import { logUserAction } from "../../logs";
export const EditItems = ({ isItemsOpen, setItemsOpen, brands, categories, record, setRecord, order, updateOrder, itemsView }) => {

    const [form] = Form.useForm();
    const { Option } = Select;
    const { TextArea } = Input;
    const querydb = getFirestore();
    const auth = getAuth();

    const [category, setCategory] = useState();
    const [sizes, setSizes] = useState();
    const [isOpenConfirm, setOpenConfirm] = useState(false);

    useEffect(() => {
        fetchData(querydb, collections.sizes, setSizes);
    }, [querydb]);

    const handleCategory = (value) => {
        setCategory(value);
    }

    const closeForm = () => {
        setRecord();
        form.resetFields();
        setTimeout(() => {
            if (record === undefined) {
                setItemsOpen(false);
            }
        }, 2000);
    }

    const handleEdit = async (values) => {
        try {
            const productList = order.products.filter((product) => product.sku !== record.sku);
            const changes = {
                brand: typeof values.brand !== "undefined" && values.brand !== null ? values.brand.toUpperCase() : record.brand,
                category: typeof values.category !== "undefined" && values.category != null ? values.category.toUpperCase() : record.category,
                color: typeof values.color !== "undefined" && values.color !== null ? values.color.toUpperCase() : record.color,
                model: typeof values.model !== "undefined" && values.model !== null ? values.model.toUpperCase() : record.model,
                sku: typeof values.sku !== "undefined" && values.sku !== null ? values.sku.toUpperCase() : record.sku,
                size: typeof values.size !== "undefined" && values.size !== null ? values.size
                    : values.category && values.category === "Accesorios" ? "NO APLICA" : record.size,
                quantity: typeof values.quantity !== "undefined" && values.quantity !== null ? values.quantity : record.quantity,
                total: typeof values.total !== "undefined" && values.total !== null ? values.total : record.total,
                observation: typeof values.observation !== "undefined" && values.observation !== null ?
                    values.observation.toUpperCase() : record.observation ? record.observation : "SIN OBSERVACIONES"
            };
            productList.push(changes);
            let newTotal = productList.map((product) => Number(product.total)).reduce((a, b) => a + b);
            await updateDoc(doc(querydb, "orders", order.key), {
                products: productList,
                saleAmount: newTotal,
                payable: (newTotal + order.shippingAmount) - order.advanceDelivery,
            });
            logUserAction(querydb, auth, "EDIT_ITEM", order.serial, record.sku, changes, APP_VERSION);
            await updateOrder();
            setRecord();
            form.resetFields();
        } catch (error) {
            console.log(error);
        }
    }

    const handleConfirm = () => {
        setTimeout(() => {
            form.submit();
            setOpenConfirm(false);
            setItemsOpen(false);
            itemsView(false);
        }, 2000);
    }

    return (
        <>
            {!record ? null : (
                <Modal
                    open={isItemsOpen}
                    onCancel={closeForm}
                    footer={null}
                    title={order ? `Editando item ${record.sku} del pedido #${order.serial}` : null}
                >
                    <Form
                        form={form}
                        layout="vertical"
                        autoComplete="off"
                        onFinish={handleEdit}
                    >
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="brand"
                                    label="Marca"
                                >
                                    <Select defaultValue={record.brand}>
                                        {brands && brands.length ?
                                            brands.filter(brand => brand.status !== false).map((brand, i) => <Option value={brand.name} key={i}>{brand.name}</Option>)
                                            : null}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="category"
                                    label="Categoria"
                                >
                                    <Select defaultValue={record.category} onChange={handleCategory}>
                                        {categories && categories.length ?
                                            categories.map((category, i) => <Option value={category.name} key={i}>{category.name}</Option>)
                                            : null
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="color"
                                    label="Color"
                                    rules={[
                                        {
                                            required: false
                                        },
                                        {
                                            validator: validateColor
                                        }
                                    ]}
                                >
                                    <Input defaultValue={record.color} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="model"
                                    label="Modelo"
                                >
                                    <Input defaultValue={record.model} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="sku"
                                    label="Sku"
                                >
                                    <Input defaultValue={record.sku} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="size"
                                    label="Talla"
                                >
                                    <Select defaultValue={record.size}>
                                        {sizes && sizes.length && category ?
                                            sizes.filter(size => size.type === checkCategory(category)).map((size, i) => <Option value={size.size} key={i}>{size.size}</Option>) :
                                            sizes && sizes.length ?
                                                sizes.filter(size => size.type === checkCategory(record.category)).map((size, i) => <Option value={size.size} key={i}>{size.size}</Option>) :
                                                null
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="quantity"
                                    label="Cantidad"
                                    rules={[
                                        {
                                            required: false
                                        },
                                        {
                                            validator: validateQty
                                        }
                                    ]}
                                >
                                    <InputNumber defaultValue={record.quantity} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="total"
                                    label="Total"
                                    rules={[
                                        {
                                            required: false
                                        },
                                        {
                                            validator: validatePrice
                                        }
                                    ]}
                                >
                                    <InputNumber defaultValue={record.total} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="observation"
                                    label="Observaciones"
                                >
                                    <TextArea defaultValue={record.observation} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Button onClick={closeForm} className="btnCancel">Cancelar</Button>
                            <Form.Item>
                                <Popconfirm
                                    title="Modificar y guardar item?"
                                    okText="Si"
                                    cancelText="No"
                                    open={isOpenConfirm}
                                    onConfirm={handleConfirm}
                                    onCancel={() => setOpenConfirm(false)}
                                >
                                    <Button type="primary" onClick={() => setOpenConfirm(true)} className="btnOK button-right">Guardar</Button>
                                </Popconfirm>
                            </Form.Item>
                        </Row>
                    </Form>
                </Modal>
            )}
        </>
    );
}